var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubstationOperation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3791_6486)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#D82428"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 4.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.666 9.33301C19.0341 9.33302 19.3328 9.63099 19.333 9.99902V11.333H21.333V10.666C21.333 10.2979 21.631 9.99921 21.999 9.99902C22.3672 9.99902 22.666 10.2978 22.666 10.666V11.333H23.999V10.666C23.999 10.2978 24.2978 9.99902 24.666 9.99902C25.0342 9.99903 25.333 10.2978 25.333 10.666V11.333L25.4668 11.3467C25.7706 11.4088 25.9989 11.677 25.999 11.999C25.999 12.3671 25.701 12.6658 25.333 12.666H23.6084L19.333 16.9414V23.333C19.3328 23.701 19.0341 23.999 18.666 23.999C18.2979 23.999 17.9992 23.701 17.999 23.333V16.9414L13.7236 12.666H11.999C11.631 12.6658 11.333 12.3671 11.333 11.999C11.3332 11.6769 11.5615 11.4088 11.8652 11.3467L11.999 11.333V10.666C11.999 10.2978 12.2978 9.99903 12.666 9.99902C13.0342 9.99902 13.333 10.2978 13.333 10.666V11.333H14.666V10.666C14.666 10.2978 14.9648 9.99902 15.333 9.99902C15.701 9.9992 15.999 10.2979 15.999 10.666V11.333H17.999V9.99902C17.9992 9.63098 18.2979 9.33301 18.666 9.33301ZM17.999 15.0566V12.666H15.6084L17.999 15.0566ZM19.333 12.666V15.0566L21.7236 12.666H19.333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3791_6486",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3791_6486"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3791_6486",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstationOperation);
export default __webpack_public_path__ + "static/media/substation_operation.059f8de1c6152d632f71f83730b0007e.svg";
export { ForwardRef as ReactComponent };